import { PropsWithChildren } from "react";
import { Control, FieldValues, Path, useController } from "react-hook-form";
import styled from "styled-components";

import { Label } from ".";
import ValidationMessage from "./ValidationMessage";

const StyledLabel = styled(Label)`
  position: relative;
  cursor: pointer;
  user-select: none;
  margin: 0;
  padding-left: 25px;
`;

const Checkmark = styled.span`
  width: 16px;
  height: 16px;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  position: absolute;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 1px;
  transition: 0.2s ease-out all;
  &::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 1px;
    width: 5px;
    height: 9px;
    border: solid ${({ theme }) => theme.colors.white};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: none;
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  &:checked ~ ${Checkmark} {
    background: ${({ theme }) => theme.colors.purple};
    border-color: ${({ theme }) => theme.colors.purple};
    &::after {
      display: block;
    }
  }
`;

interface Props<T extends FieldValues> {
  className?: string;
  name: Path<T>;
  control: Control<T>;
}

const Checkbox = <T extends FieldValues>({
  children,
  className,
  name,
  control,
}: PropsWithChildren<Props<T>>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <>
      <StyledLabel className={className}>
        {children}
        <Input type="checkbox" checked={value} onChange={onChange} />
        <Checkmark />
      </StyledLabel>
      {!!error && <ValidationMessage>{error.message}</ValidationMessage>}
    </>
  );
};

export default Checkbox;
